import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=18d89a28&scoped=true&"
import script from "./Paginator.vue?vue&type=script&lang=js&"
export * from "./Paginator.vue?vue&type=script&lang=js&"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=18d89a28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d89a28",
  null
  
)

export default component.exports